import React, { useEffect, useState } from "react"
import { Appearance } from "react-native"
import { observer } from "mobx-react-lite"
import { View } from "native-base"
import { IViewProps } from "native-base/lib/typescript/components/primitives/View"
import zxcvbn from "zxcvbn"

export interface PasswordStrengthMeterBarProps extends IViewProps {
  value: string

  colorScheme?: "light"|"dark"
}

/**
 * Password Strength Meter Bar
 */
export const PasswordStrengthMeterBar = observer(function PasswordStrengthMeterBar(props: PasswordStrengthMeterBarProps) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    value,
    ...restProps
  } = props
  const [ score, setScore ] = useState<number>(-1)

  useEffect(() => {
    if (!value && score < 0) return;
    const result = zxcvbn(value)
    if (score !== result.score) setScore(result.score)
  }, [score, value])

  const disabledColor = colorScheme === "light" ? "gray.200" : "gray.800"
  const color = [
    colorScheme === "light" ? "red.700" : "red.300",
    colorScheme === "light" ? "red.500" : "red.500",
    colorScheme === "light" ? "orange.300" : "orange.700",
    colorScheme === "light" ? "green.500" : "green.500",
    colorScheme === "light" ? "green.700" : "green.300",
  ][score] || disabledColor

  return (
    <View flexDirection="row" height="3px" {...restProps}>
      <View flex={1} backgroundColor={score >= 0 ? color : disabledColor}></View>
      <View width="4px"></View>
      <View flex={1} backgroundColor={score >= 1 ? color : disabledColor}></View>
      <View width="4px"></View>
      <View flex={1} backgroundColor={score >= 2 ? color : disabledColor}></View>
      <View width="4px"></View>
      <View flex={1} backgroundColor={score >= 3 ? color : disabledColor}></View>
      <View width="4px"></View>
      <View flex={1} backgroundColor={score >= 4 ? color : disabledColor}></View>
    </View>
  )
})
